import { PageMeta, PageRequest } from '@/app/core/models/paged-result.model';
import {
  HospitalAccount,
  HospitalAccountFilters,
  HospitalAccountPage,
} from '../models/hospital-account.model';
import {
  HospitalAccountApiItem,
  HospitalAccountApiMeta,
  HospitalAccountApiResponse,
} from './hospital-account-api.types';

export function toApiQueryParams(
  filters: HospitalAccountFilters,
  page: PageRequest,
): Record<string, string | number> {
  return { page: page.page, size: page.size, ...toApiFilterParams(filters) };
}

export function toApiFilterParams(
  filters: HospitalAccountFilters,
): Record<string, string | number> {
  const params: Record<string, string | number> = {};
  if (filters.startDate) params['startDate'] = filters.startDate;
  if (filters.endDate) params['endDate'] = filters.endDate;
  if (filters.patientRut) params['patientRut'] = filters.patientRut;
  if (filters.stNumber !== undefined) params['stNumber'] = filters.stNumber;
  return params;
}

export function toPageMeta(meta: HospitalAccountApiMeta): PageMeta {
  return {
    page: meta.page,
    size: meta.limit,
    totalElements: meta.total,
    totalPages: Math.max(meta.totalPages, 1),
    hasNextPage: meta.hasNextPage,
    hasPrevPage: meta.hasPrevPage,
  };
}

export function toHospitalAccount(item: HospitalAccountApiItem): HospitalAccount {
  return {
    stNumber: item.stNumber,
    providerRut: item.providerRut,
    accountNumber: item.accountNumber,
    amount: item.amount,
    patientRut: item.patientRut.toLowerCase(),
    status: item.status,
    lastStatusDate: item.lastStatusDate,
    hospitalizationDate: item.hospitalizationDate,
    receptionDate: item.receptionDate,
    objectionDate: item.objectionDate,
    objectionDetail: null,
    issueDate: item.issueDate,
  };
}

export function toHospitalAccountPage(response: HospitalAccountApiResponse): HospitalAccountPage {
  return {
    content: response.data.map(toHospitalAccount),
    page: toPageMeta(response.meta),
  };
}
